// 3rd Party
import propTypes from 'prop-types';
import React from 'react';

import { P } from 'common/styles/oc-styled-components';
import { Radio } from 'opencare-crown';

// Components

import { SelectButton } from './styled-components';

export const ToggleSelect = ({ label, options, value, onChange }) => {
  const optionsList = options.map(option => (
    <SelectButton key={option} value={option}>
      <P fontSize="16px" fontWeight="600" margin="0">
        {option}
      </P>
    </SelectButton>
  ));

  return (
    <>
      {label 
        && (
          <P fontSize="14px" display="inline">
            {label}
          </P>
        )
      }
      <Radio.Group
        className="sensitive-data"
        buttonStyle="solid"
        onChange={onChange}
        style={{ marginTop: 5, display: 'flex' }}
        value={value}
      >
        {optionsList}
      </Radio.Group>
    </>
  );
};
ToggleSelect.propTypes = {
  label: propTypes.string,
  options: propTypes.arrayOf(propTypes.string),
  value: propTypes.string,
  onChange: propTypes.func,
};
